export const partnersLogos = [
  { id: 1, name: 'Universiti Teknologi MARA', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=UiTM' },
  { id: 2, name: 'IIU College of Law and Applied Studies', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=IIU' },
  { id: 3, name: 'Eastern University Sri Lanka', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Eastern+Uni' },
  { id: 4, name: 'Metharath University', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Metharath' },
  { id: 5, name: 'Kathmandu University', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Kathmandu' },
  { id: 6, name: 'Mother Teresa Women\'s University', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=MTWU' },
  { id: 7, name: 'Saveetha School of Management', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Saveetha' },
  { id: 8, name: 'Achariya', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Achariya' },
  { id: 9, name: 'Prashanth Hospital', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Prashanth' },
  { id: 10, name: 'Dhruva HealthElevate Consultancy', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Dhruva' },
  { id: 11, name: 'Saveetha College of Liberal Arts', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=SCLAS' },
  { id: 12, name: 'Drizzle Hospitality Group', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Drizzle' },
  { id: 13, name: 'News 7 Tamil', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=News+7' },
  { id: 14, name: 'Institute of Medical & Technological Sciences', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=IMTS' },
  { id: 15, name: 'Ariraj Annapackiam College', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Ariraj' },
  { id: 16, name: 'Mentor', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Mentor' },
  { id: 17, name: 'Agriculture Hub', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Agri+Hub' },
  { id: 18, name: 'Dhushima Thamizhagam UAE', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Dhushima' },
  { id: 19, name: 'Students Xerox', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Students' },
  { id: 20, name: 'Savvyan Technologies', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Savvyan' },
  { id: 21, name: 'Turyaa', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Turyaa' },
  { id: 22, name: 'MERD International Institute', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=MERD' },
  { id: 23, name: 'LOSD Global Research', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=LOSD' },
  { id: 24, name: 'Aruvi Restaurant', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=Aruvi' },
  { id: 25, name: 'Skill Development Training Center LLC', logo: 'https://via.placeholder.com/180x90/143d5f/4caf50?text=SDTC' },
];

export const reviews = [
  {
    id: 1,
    author: 'Dr. Rajesh Kumar',
    rating: 5,
    text: 'Excellent publication house with professional service. Published my research book smoothly.',
    date: 'January 2025'
  },
  {
    id: 2,
    author: 'Prof. Meera Patel',
    rating: 5,
    text: 'Outstanding quality and timely delivery. Highly recommended for academic publications.',
    date: 'December 2024'
  },
  {
    id: 3,
    author: 'Dr. Arun Sharma',
    rating: 5,
    text: 'Professional team with great support. My book chapter was published beautifully.',
    date: 'November 2024'
  },
];

export const publishedBooks = [
  {
    id: 1,
    title: 'Latest Innovation for Future Education',
    editor: 'J. Banuchandar',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+1',
    isbn: '978-93-90781-11-9'
  },
  {
    id: 2,
    title: 'COVID-19 and Its Impact',
    editor: 'Multiple Authors',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+2',
    isbn: '978-81-947019-4-1'
  },
  {
    id: 3,
    title: '1111 Poems 1111 Poets',
    editor: 'ESN Editorial Team',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+3',
    isbn: '978-93-90781-11-9'
  },
  {
    id: 4,
    title: 'Research Anthology Volume 1',
    editor: 'Dr. R. Nivethikha',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+4',
    isbn: '978-93-90781-12-6'
  },
  {
    id: 5,
    title: 'Academic Excellence 2024',
    editor: 'Prof. K. Ramesh',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+5',
    isbn: '978-93-90781-13-3'
  },
  {
    id: 6,
    title: 'Multidisciplinary Research',
    editor: 'Dr. S. Priya',
    cover: 'https://via.placeholder.com/300x400/302f2c/d9fb06?text=Book+6',
    isbn: '978-93-90781-14-0'
  },
];

export const upcomingBookChapters = [
  {
    id: 1,
    bookName: 'Future of Education 2025',
    editor: 'Dr. Anand Kumar',
    category: 'Education',
    isbn: '978-93-90781-15-7',
    status: 'Accepting Submissions'
  },
  {
    id: 2,
    bookName: 'Artificial Intelligence in Research',
    editor: 'Prof. Lakshmi Iyer',
    category: 'Technology',
    isbn: '978-93-90781-16-4',
    status: 'Open for Chapters'
  },
  {
    id: 3,
    bookName: 'Sustainable Development Goals',
    editor: 'Dr. Vinod Mehta',
    category: 'Environment',
    isbn: '978-93-90781-17-1',
    status: 'Accepting Submissions'
  },
];

export const recordsData = {
  guinness: {
    logo: '/records/logos/guinness-logo.png',
    records: [
      {
        id: 1,
        title: 'THICKEST BOOK IN THE WORLD',
        date: '26 JULY 2023',
        place: 'Chennai',
        description: 'ESN Publications, in collaboration with the London Organisation of Skills Development Ltd, holds the Guinness World Record for the thickest unpublished book. The book, which contains 100,100 pages and measures 5.80 meters (19 ft 0.34 in) in thickness, was created to promote reading and writing. It includes research papers from universities in India and the UK.',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Record+Image+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Record+Image+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Record+Image+3',
        ]
      }
    ]
  },
  worldBook: {
    logo: '/records/logos/world-book-logo.png',
    records: [
      {
        id: 1,
        title: '150 HOURS CONTINUOUS PRESENTATION',
        date: '03 TO 09TH SEPTEMBER 2020',
        place: 'Chennai',
        description: 'ESN publications from Chennai has set its record for organizing the longest international conferences following the duration of 150 hours continuously from 03 to 09 September 2020 at hotel Turyaa, OMR Road Perungudi, Chennai (Tamil Nadu) India.',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=150+Hours+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=150+Hours+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=150+Hours+3',
        ]
      },
      {
        id: 2,
        title: 'THICKEST BOOK OF THE WORLD',
        date: '30TH JANUARY 2021',
        place: 'Chennai',
        description: 'ESN Publications published the Thickest Book of the World containing 1210 research papers and 11,796 pages under the supervision of its Founder Chairman Mr. J. Banuchandar. The book focuses on innovative and unique ways to education in future times.',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Thickest+Book+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Thickest+Book+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Thickest+Book+3',
        ]
      },
      {
        id: 3,
        title: '1111 POEMS 1111 POETS',
        date: '15TH AUGUST 2022',
        place: 'Chennai',
        description: 'ESN publications from Chennai has set its second record by publishing 1111 poems 1111 poets as a single book with ISBN 978-93-90781-11-9 in multiple languages on 17 November 2021. The poems came in six languages- English, Hindi, Tamil, Telugu, Odisha and Arabic.',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Poems+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Poems+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Poems+3',
        ]
      }
    ]
  },
  indiaBook: {
    logo: '/records/logos/india-book-logo.png',
    records: [
      {
        id: 1,
        title: 'MAXIMUM AUTHORS CONTRIBUTING TO A BOOK ON COVID-19 AND ITS IMPACT',
        date: '05 JUNE 2021',
        place: 'Chennai',
        description: 'The record for the maximum number of authors contributing to a book on COVID-19 and its impact was set by ESN Publications, India, under the guidance of J. Banuchandar, Founder and Chairman. A total of 1,498 authors across the world contributed articles to the book titled COVID-19 AND ITS IMPACT (ISBN: 978-81-947019-4-1).',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=COVID+Book+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=COVID+Book+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=COVID+Book+3',
        ]
      },
      {
        id: 2,
        title: '7575 POEMS',
        date: '30TH JULY 2022',
        place: 'Chennai',
        description: 'The Record is an international anthology of work by poets from various countries. There\'s something for every taste: new voices as well as the world\'s greats. The Record marks the first time 7575 Poems in Multiple Languages from so many countries have been gathered together in one anthology.',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=7575+Poems+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=7575+Poems+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=7575+Poems+3',
        ]
      }
    ]
  },
  asiaBook: {
    logo: '/records/logos/asia-book-logo.png',
    records: [
      {
        id: 1,
        title: 'MAXIMUM AUTHORS CONTRIBUTING TO A BOOK ON COVID-19 AND ITS IMPACT',
        date: '05 JUNE 2021',
        place: 'Chennai',
        description: 'The record for the maximum number of authors contributing to a book on COVID-19 and its impact was set by ESN Publications, India, under the guidance of J. Banuchandar, Founder and Chairman. A total of 1,498 authors across the world contributed articles to the book titled COVID-19 AND ITS IMPACT (ISBN: 978-81-947019-4-1).',
        images: [
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Asia+COVID+1',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Asia+COVID+2',
          'https://via.placeholder.com/800x600/302f2c/d9fb06?text=Asia+COVID+3',
        ]
      }
    ]
  }
};